// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AssistantPanel — AI 에이전트 우측 패널 (AnalysisPanel 과 같은 레일 규격) */

.AssistantPanel_panel__-PJoL {
    width: 520px;
    /* 편집기+결과 칸이 최소 폭에 닿으면 그다음은 패널이 줄어든다(App.css .editor-result-column) — 넘쳐서 잘리지 않게 */
    flex-shrink: 1;
    min-width: 340px;
    /* 오른쪽 레일에서 **늘 맨 오른쪽**(사용자 요청 2026-09-13). 이력·챌린지·데이터 분석 패널보다 뒤에 온다 —
       App.js 에서 그리는 순서가 바뀌어도 자리가 흔들리지 않게 순서를 여기서 못 박는다. */
    order: 100;
    display: flex;
    flex-direction: column;
    background: var(--color-bg, #fff);
    border-left: 1px solid var(--color-border, #e0e0e0);
    font-size: 12px;
    color: var(--color-text, #1f2937);
    overflow: hidden;
    /* **폭이 아니라 여백을 움직인다.** 폭을 줄이면 안쪽이 그때마다 다시 배치돼 글자가
       출렁인다. 음수 여백은 차지하는 자리만 줄이므로 내용은 그대로 있고 미닫이처럼 밀린다.
       에이전트 칸의 최소 폭 전환(WorkspaceDock.css .ws-agent-col)과 시간이 같아야 한다. 패널은 접혀도 내려가지 않는다(늘 작동, 2026-10-20). */
    /* 같은 레일의 사이드 패널(App.css .side-panel-area)과 **같은 시간**이다 — 둘이 다르면
       버튼을 옮겨 누를 때 한쪽만 굼떠 보인다(신고 2026-09-20). */
    transition: margin-right 260ms ease, opacity 200ms ease;
}

.AssistantPanel_panelOpen__bsjlx { margin-right: 0; opacity: 1; }

.AssistantPanel_panelClosed__TmE1J {
    margin-right: -520px;
    opacity: 0;
    pointer-events: none;
}

@media (prefers-reduced-motion: reduce) {
    .AssistantPanel_panel__-PJoL { transition: none; }
}

/* 제목줄·제목은 common/PanelHeader 가 그린다 — 여기서 또 칠하지 않는다(2026-09-20). */
.AssistantPanel_iconBtn__lpHX2 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: 1px solid transparent;
    border-radius: 4px;
    background: transparent;
    color: var(--color-text-secondary, #4b5563);
    cursor: pointer;
    transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;
}
.AssistantPanel_iconBtn__lpHX2:hover { background: var(--color-hover, #eceef1); color: var(--color-text, #1f2937); }
.AssistantPanel_iconBtn__lpHX2:disabled { opacity: .45; cursor: not-allowed; }

/* 제목 옆 계정 배지 — 실행 전에 "누구 계정으로 도는가" 가 보여야 한다.
   정상과 경고를 색으로 가른다: 계정이 없으면 턴이 아예 실패한다. */
.AssistantPanel_acct__BZAzy, .AssistantPanel_acctWarn__ztOq8 {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    /* 절대 찌그러지지 않는다. flex 기본값(shrink:1)이면 좁은 패널에서 글자가 통째로 잘려
       아이콘과 말줄임표만 남는다 — 색만 보이고 뜻은 안 보이는 상태가 된다(실제로 그랬다). */
    flex-shrink: 0;
    padding: 1px 7px;
    border-radius: 10px;
    border: 1px solid transparent;
    font-size: 10px;
    line-height: 16px;
    cursor: pointer;
    transition: background-color 150ms ease, border-color 150ms ease;
}
.AssistantPanel_acct__BZAzy {
    background: var(--color-hover, #eceef1);
    color: var(--color-text-secondary, #4b5563);
}
.AssistantPanel_acct__BZAzy:hover { border-color: var(--color-border, #d1d5db); }

.AssistantPanel_acctWarn__ztOq8 {
    background: #fef3c7;
    color: #92400e;
}
.AssistantPanel_acctWarn__ztOq8:hover { border-color: #f59e0b; }

/* 배지가 길어져도 아이콘·제목을 밀지 않는다 */
.AssistantPanel_acctText__TzKi0 { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

[data-theme="dark"] .AssistantPanel_acctWarn__ztOq8 { background: #78350f; color: #fde68a; }

/* 대화 선택 — 입력란 바로 위. 무엇에 이어서 쓰는지는 쓰기 직전에 본다. */
.AssistantPanel_threadBar__oVw3Y {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    padding: 4px 8px 0 8px;
    background: var(--color-bg-secondary, #f5f6f8);
}
.AssistantPanel_threadBar__oVw3Y .AssistantPanel_threadSelect__defYk { flex: 1 1; max-width: none; }

@media (prefers-reduced-motion: reduce) {
    .AssistantPanel_acct__BZAzy, .AssistantPanel_acctWarn__ztOq8 { transition: none; }
}

.AssistantPanel_threadSelect__defYk {
    max-width: 150px;
    padding: 2px 4px;
    font-size: 11px;
    background: var(--color-bg, #fff);
    color: var(--color-text, #1f2937);
    border: 1px solid var(--color-border, #d1d5db);
    border-radius: 4px;
}

/* 상황 표시줄 — 현재 연결/DB 종류, 세션 미바인딩 경고 */
.AssistantPanel_context__N7Qri {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    padding: 5px 10px;
    background: var(--color-bg-secondary, #f5f6f8);
    border-bottom: 1px solid var(--color-border, #e0e0e0);
    font-size: 11px;
    color: var(--color-text-muted, #6b7280);
}
/* 배지는 **select 와 같은 높이**로 세운다. 텍스트 baseline 으로 두면 옆의 선택 상자보다
   살짝 떠 보인다(실제 지적 2026-09-21). */
.AssistantPanel_badge__Gpt0h {
    display: inline-flex;
    align-items: center;
    min-height: 20px;
    padding: 1px 6px;
    border-radius: 10px;
    background: var(--color-hover, #eceef1);
    color: var(--color-text-secondary, #4b5563);
    line-height: 1;
}
.AssistantPanel_warn__IxUZL { color: #b45309; }

/* 토큰 사용량 — 항상 보이되 대화를 가리지 않게 가장 작고 흐리게 */
.AssistantPanel_usageBar__i\\+f\\+F {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 10px;
    border-bottom: 1px solid var(--color-border-light, #eee);
    background: var(--color-bg-secondary, #f5f6f8);
    font-size: 10.5px;
    color: var(--color-text-muted, #6b7280);
    animation: AssistantPanel_usage-in__VunZ0 150ms ease-out;
}
.AssistantPanel_usageDim__R3TNe { opacity: 0.75; }
.AssistantPanel_usageCost__odyXR { margin-left: auto; font-variant-numeric: tabular-nums; }

@keyframes AssistantPanel_usage-in__VunZ0 { from { opacity: 0; } to { opacity: 1; } }
@media (prefers-reduced-motion: reduce) { .AssistantPanel_usageBar__i\\+f\\+F { animation: none; } }

[data-theme="dark"] .AssistantPanel_usageBar__i\\+f\\+F {
    border-bottom-color: rgba(160, 160, 160, 0.18);
}

/* 스킬 수준 — 뱃지와 같은 줄에 두되 **누를 수 있다는 것**이 보여야 한다 */
.AssistantPanel_skillSelect__zpEcJ {
    margin-left: auto;
    max-width: 96px;
    min-height: 20px;
    padding: 1px 4px;
    border: 1px solid var(--color-border, #d0d5dd);
    border-radius: 4px;
    background: var(--color-bg, #ffffff);
    color: var(--color-text-secondary, #4b5563);
    font-size: 11px;
    cursor: pointer;
    transition: border-color 150ms ease, color 150ms ease;
}

.AssistantPanel_skillSelect__zpEcJ:hover {
    border-color: var(--color-primary, #2f6fd0);
    color: var(--color-primary, #2f6fd0);
}

/* 튜닝 수준은 문구가 길다("L6 Change Index") — 스킬 수준과 같은 폭이면 잘린다.
   \`margin-left\` 는 앞의 스킬 수준이 이미 auto 로 밀었으므로 여기서는 붙어 선다. */
.AssistantPanel_tuneSelect__e1a4P {
    margin-left: 0;
    max-width: 168px;
}

/* 수준 칸의 레이블(2026-10-29) — 「스킬 수준 [개발자]」 「SQL 튜닝 수준 [L4 …]」. 오른쪽 끝으로 미는 것은 첫 칸이 한다 */
.AssistantPanel_levelField__BrAjA {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin: 0;
}
.AssistantPanel_levelFieldFirst__A1SWS {
    margin-left: auto;
}
.AssistantPanel_levelField__BrAjA .AssistantPanel_skillSelect__zpEcJ {
    margin-left: 0;
}
.AssistantPanel_levelLabel__SbkTD {
    font-size: 11px;
    color: var(--color-text-secondary, #6b7280);
    white-space: nowrap;
}

/* 메시지 목록 */
/* .list 를 감싸 "맨 아래로" 버튼을 띄울 자리를 만든다 — 스크롤과 같이 움직이면 안 된다 */
.AssistantPanel_listWrap__7RCtX {
    position: relative;
    flex: 1 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

/* 바닥에서 떨어져 있을 때만 나온다. 따라가기가 꺼졌다는 **표시**이자 되돌아갈 길이다 */
.AssistantPanel_toBottom__KNUQf {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    border: 1px solid var(--color-border, #d0d5dd);
    border-radius: 999px;
    background: var(--color-bg-elevated, #ffffff);
    color: var(--color-text, #344054);
    font-size: 11px;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
    animation: AssistantPanel_assistant-to-bottom-in__sztq1 150ms ease-out;
}

.AssistantPanel_toBottom__KNUQf:hover {
    border-color: var(--color-primary, #2f6fd0);
    color: var(--color-primary, #2f6fd0);
}

@keyframes AssistantPanel_assistant-to-bottom-in__sztq1 {
    from { opacity: 0; transform: translateX(-50%) translateY(3px); }
    to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
    .AssistantPanel_toBottom__KNUQf { animation: none; }
}

[data-theme="dark"] .AssistantPanel_toBottom__KNUQf {
    background: #23262b;
    border-color: rgba(160, 160, 160, 0.32);
    color: #d6dae0;
}

.AssistantPanel_list__sxBm8 {
    flex: 1 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 8px 10px 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.AssistantPanel_empty__TSgsD {
    margin: auto;
    text-align: center;
    color: var(--color-text-muted, #6b7280);
    font-size: 11px;
    line-height: 1.7;
    padding: 16px;
}
.AssistantPanel_empty__TSgsD strong { display: block; margin-bottom: 6px; color: var(--color-text, #1f2937); font-size: 12px; }
.AssistantPanel_exampleBtn__-olv8 {
    display: block;
    width: 100%;
    margin-top: 6px;
    padding: 6px 8px;
    text-align: left;
    background: var(--color-bg-secondary, #f5f6f8);
    border: 1px solid var(--color-border, #e5e7eb);
    border-radius: 4px;
    color: var(--color-text-secondary, #4b5563);
    font-size: 11px;
    cursor: pointer;
    transition: background-color 150ms ease, border-color 150ms ease;
}
.AssistantPanel_exampleBtn__-olv8:hover { background: var(--color-hover, #eceef1); border-color: var(--color-border-strong, #9ca3af); }

.AssistantPanel_bubble__GNVvZ {
    padding: 7px 9px;
    border-radius: 6px;
    line-height: 1.6;
    word-break: break-word;
    animation: AssistantPanel_asst-in__RcjcK 140ms ease-out;
}
.AssistantPanel_user__nPm6f {
    align-self: flex-end;
    max-width: 88%;
    background: var(--color-accent, #2563eb);
    color: #fff;
    white-space: pre-wrap;
}
/* 긴 사용자 메시지의 펼치기 — 말풍선(파란 배경) 안이라 흰 글씨 기준으로 맞춘다 */
.AssistantPanel_userMore__whgPP {
    display: block;
    margin-top: 5px;
    padding: 2px 7px;
    border: 1px solid rgba(255, 255, 255, 0.45);
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.14);
    color: inherit;
    font-size: 10.5px;
    cursor: pointer;
    transition: background-color 150ms ease;
}
.AssistantPanel_userMore__whgPP:hover { background: rgba(255, 255, 255, 0.26); }

@media (prefers-reduced-motion: reduce) { .AssistantPanel_userMore__whgPP { transition: none; } }

.AssistantPanel_assistant__3UAfH {
    background: var(--color-bg-secondary, #f5f6f8);
    border: 1px solid var(--color-border, #e5e7eb);
}
.AssistantPanel_assistant__3UAfH p { margin: 0 0 6px; }
.AssistantPanel_assistant__3UAfH p:last-child { margin-bottom: 0; }
.AssistantPanel_assistant__3UAfH ul, .AssistantPanel_assistant__3UAfH ol { margin: 4px 0 6px; padding-left: 18px; }
.AssistantPanel_assistant__3UAfH table { border-collapse: collapse; font-size: 11px; display: block; overflow-x: auto; }
.AssistantPanel_assistant__3UAfH th, .AssistantPanel_assistant__3UAfH td { border: 1px solid var(--color-border, #e5e7eb); padding: 2px 5px; }
.AssistantPanel_assistant__3UAfH code {
    background: var(--color-hover, #eceef1);
    padding: 1px 4px;
    border-radius: 3px;
    font-family: Consolas, 'Courier New', monospace;
    font-size: 11px;
}

.AssistantPanel_errorBubble__HdPzA {
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #b91c1c;
    display: flex;
    gap: 6px;
    align-items: flex-start;
}

/* 도구 호출 줄 */
.AssistantPanel_tool__uwWkJ {
    font-size: 11px;
    color: var(--color-text-muted, #6b7280);
    border-left: 2px solid var(--color-border, #e5e7eb);
    padding: 2px 0 2px 8px;
}
.AssistantPanel_toolHead__Z7260 {
    display: flex;
    align-items: center;
    gap: 5px;
    background: none;
    border: none;
    padding: 0;
    color: inherit;
    font: inherit;
    cursor: pointer;
    text-align: left;
    width: 100%;
}
.AssistantPanel_toolName__vEofV { font-weight: 600; color: var(--color-text-secondary, #4b5563); }
.AssistantPanel_toolFail__G9-0- { color: #b91c1c; }
.AssistantPanel_toolBody__qEyYj {
    margin: 4px 0 0;
    padding: 5px 6px;
    background: var(--color-bg-secondary, #f5f6f8);
    border-radius: 4px;
    font-family: Consolas, 'Courier New', monospace;
    font-size: 10.5px;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-all;
    max-height: 220px;
    overflow: auto;
    animation: AssistantPanel_asst-in__RcjcK 140ms ease-out;
}

/* SQL 블록 */
.AssistantPanel_sqlBlock__3dF\\+H {
    border: 1px solid var(--color-border, #e5e7eb);
    border-radius: 6px;
    overflow: hidden;
    background: var(--color-bg, #fff);
}
.AssistantPanel_sqlBar__0HRL8 {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 6px;
    background: var(--color-bg-secondary, #f5f6f8);
    border-bottom: 1px solid var(--color-border, #e5e7eb);
}
.AssistantPanel_sqlBarLabel__RKxnT { flex: 1 1; font-size: 10.5px; color: var(--color-text-muted, #6b7280); font-weight: 600; }
.AssistantPanel_sqlCode__Y\\+3tj {
    margin: 0;
    padding: 7px 8px;
    font-family: Consolas, 'Courier New', monospace;
    font-size: 11.5px;
    line-height: 1.55;
    white-space: pre;
    overflow-x: auto;
}
.AssistantPanel_rationale__2VtvM {
    padding: 5px 8px 7px;
    border-top: 1px dashed var(--color-border, #e5e7eb);
    font-size: 11px;
    color: var(--color-text-secondary, #4b5563);
    line-height: 1.6;
    white-space: pre-wrap;
}
.AssistantPanel_smallBtn__E\\+0qG {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 3px 8px;
    background: var(--color-bg, #fff);
    color: var(--color-text, #1f2937);
    border: 1px solid var(--color-border, #d1d5db);
    border-radius: 4px;
    font-size: 10.5px;
    cursor: pointer;
    transition: background-color 150ms ease, border-color 150ms ease;
}
.AssistantPanel_smallBtn__E\\+0qG:hover:not(:disabled) { background: var(--color-hover, #f3f4f6); border-color: var(--color-border-strong, #9ca3af); }
.AssistantPanel_smallBtn__E\\+0qG:disabled { opacity: .45; cursor: not-allowed; }

/* 되묻기 카드 */
.AssistantPanel_question__PP7uB {
    border: 1px solid var(--color-accent, #2563eb);
    border-radius: 6px;
    background: var(--color-bg, #fff);
    overflow: hidden;
}
.AssistantPanel_questionHead__N9z6A {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 8px;
    background: color-mix(in srgb, var(--color-accent, #2563eb) 10%, transparent);
    font-size: 10.5px;
    font-weight: 600;
    color: var(--color-accent, #2563eb);
}
/* 줄바꿈을 살린다 — 승인 창(임시 인덱스·execute_sql)은 실행할 문장을 여러 줄로 보여 준다. 긴 문장은 칸 안에서 스크롤 */
.AssistantPanel_questionText__398-m { padding: 7px 8px 4px; line-height: 1.6; white-space: pre-wrap; overflow-wrap: anywhere; max-height: 320px; overflow-y: auto; }
.AssistantPanel_options__HrNR5 { display: flex; flex-direction: column; gap: 4px; padding: 4px 8px 8px; }
.AssistantPanel_optionBtn__2q1lu {
    display: block;
    width: 100%;
    text-align: left;
    padding: 6px 8px;
    background: var(--color-bg-secondary, #f5f6f8);
    border: 1px solid var(--color-border, #d1d5db);
    border-radius: 4px;
    color: var(--color-text, #1f2937);
    font-size: 11.5px;
    cursor: pointer;
    transition: background-color 150ms ease, border-color 150ms ease;
}
.AssistantPanel_optionBtn__2q1lu:hover:not(:disabled) { background: var(--color-hover, #eceef1); border-color: var(--color-accent, #2563eb); }
.AssistantPanel_optionBtn__2q1lu:disabled { opacity: .5; cursor: not-allowed; }
.AssistantPanel_optionDesc__ePIkI { display: block; margin-top: 2px; font-size: 10.5px; color: var(--color-text-muted, #6b7280); }
.AssistantPanel_optionPicked__8Fk4g { border-color: var(--color-accent, #2563eb); background: color-mix(in srgb, var(--color-accent, #2563eb) 12%, transparent); }
/* 도움말 안내 + 선택 버튼 — 되묻기 카드와 달리 가로로 감싼다(라벨이 짧고 개수가 많다) */
.AssistantPanel_helpWrap__e6PdW { display: flex; flex-direction: column; gap: 6px; animation: AssistantPanel_help-in__HaYV2 160ms ease-out; }
.AssistantPanel_helpOptions__pln5m { display: flex; flex-wrap: wrap; gap: 5px; padding-left: 4px; }
.AssistantPanel_helpOptionBtn__VHOSG {
    padding: 4px 10px;
    border: 1px solid var(--color-accent, #2563eb);
    border-radius: 14px;
    background: transparent;
    color: var(--color-accent, #2563eb);
    font-size: 11.5px;
    cursor: pointer;
    transition: background 150ms ease, color 150ms ease;
}
.AssistantPanel_helpOptionBtn__VHOSG:hover { background: var(--color-accent, #2563eb); color: #fff; }
@keyframes AssistantPanel_help-in__HaYV2 { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }
@media (prefers-reduced-motion: reduce) { .AssistantPanel_helpWrap__e6PdW { animation: none; } .AssistantPanel_helpOptionBtn__VHOSG { transition: none; } }

.AssistantPanel_freeRow__NiJ\\+Z { display: flex; gap: 4px; padding: 0 8px 8px; }
.AssistantPanel_freeInput__-te5r {
    flex: 1 1;
    min-width: 0;
    padding: 5px 7px;
    background: var(--color-bg, #fff);
    color: var(--color-text, #1f2937);
    border: 1px solid var(--color-border, #d1d5db);
    border-radius: 4px;
    font-size: 11.5px;
}
.AssistantPanel_resolved__rjONg {
    padding: 5px 8px 7px;
    font-size: 11px;
    color: var(--color-text-muted, #6b7280);
    border-top: 1px dashed var(--color-border, #e5e7eb);
}
.AssistantPanel_resolved__rjONg strong { color: var(--color-text, #1f2937); }

/* 스트리밍 표시 */
.AssistantPanel_streaming__1Zems { opacity: .85; }
.AssistantPanel_caret__nkmKD {
    display: inline-block;
    width: 6px;
    height: 12px;
    margin-left: 2px;
    background: var(--color-text-muted, #6b7280);
    vertical-align: text-bottom;
    animation: AssistantPanel_asst-blink__wlxSa 1s steps(2, start) infinite;
}
@keyframes AssistantPanel_asst-blink__wlxSa { to { visibility: hidden; } }

/* 입력창 */
.AssistantPanel_composer__SYO5M {
    flex-shrink: 0;
    border-top: 1px solid var(--color-border, #e0e0e0);
    padding: 7px 8px;
    background: var(--color-bg-secondary, #f5f6f8);
}
.AssistantPanel_textarea__w586V {
    width: 100%;
    /* 같은 규칙에 min-height 를 두 번 쓰면 뒤엣것이 이긴다 — 한 번만 둔다 */
    min-height: 88px;
    max-height: 320px;
    resize: vertical;
    padding: 6px 7px;
    background: var(--color-bg, #fff);
    color: var(--color-text, #1f2937);
    border: 1px solid var(--color-border, #d1d5db);
    border-radius: 4px;
    font-family: inherit;
    font-size: 12px;
    line-height: 1.5;
    box-sizing: border-box;
}
.AssistantPanel_textarea__w586V:focus { outline: none; border-color: var(--color-accent, #2563eb); }
.AssistantPanel_composerBar__kv41J { display: flex; align-items: center; gap: 6px; margin-top: 5px; }
.AssistantPanel_composerHint__kzbBW { flex: 1 1; font-size: 10.5px; color: var(--color-text-muted, #6b7280); }
.AssistantPanel_sendBtn__ZRfXD {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 5px 12px;
    background: var(--color-accent, #2563eb);
    color: #fff;
    border: 1px solid var(--color-accent, #2563eb);
    border-radius: 4px;
    font-size: 11.5px;
    cursor: pointer;
    transition: opacity 150ms ease;
}
.AssistantPanel_sendBtn__ZRfXD:disabled { opacity: .45; cursor: not-allowed; }
.AssistantPanel_checkbox__9vhJW { display: inline-flex; align-items: center; gap: 4px; font-size: 10.5px; color: var(--color-text-muted, #6b7280); cursor: pointer; }

/* 계정 안내(로그인/토큰 없음) */
.AssistantPanel_notice__EVeE0 {
    margin: 8px 10px;
    padding: 8px 10px;
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 6px;
    font-size: 11px;
    line-height: 1.6;
    color: #92400e;
}
.AssistantPanel_notice__EVeE0 strong { display: block; margin-bottom: 3px; }

/* 다크 테마 */
[data-theme="dark"] .AssistantPanel_panel__-PJoL { background: var(--color-bg); border-left-color: var(--color-border); color: var(--color-text); }
[data-theme="dark"] .AssistantPanel_header__pzQ8K,
[data-theme="dark"] .AssistantPanel_context__N7Qri,
[data-theme="dark"] .AssistantPanel_composer__SYO5M { background: var(--color-bg-secondary); border-color: var(--color-border); }
[data-theme="dark"] .AssistantPanel_assistant__3UAfH,
[data-theme="dark"] .AssistantPanel_toolBody__qEyYj { background: var(--color-bg-secondary); border-color: var(--color-border); }
[data-theme="dark"] .AssistantPanel_sqlBlock__3dF\\+H,
[data-theme="dark"] .AssistantPanel_question__PP7uB,
[data-theme="dark"] .AssistantPanel_threadSelect__defYk,
[data-theme="dark"] .AssistantPanel_textarea__w586V,
[data-theme="dark"] .AssistantPanel_freeInput__-te5r,
[data-theme="dark"] .AssistantPanel_smallBtn__E\\+0qG,
[data-theme="dark"] .AssistantPanel_optionBtn__2q1lu,
[data-theme="dark"] .AssistantPanel_exampleBtn__-olv8 { background: var(--color-bg); color: var(--color-text); border-color: var(--color-border); }
[data-theme="dark"] .AssistantPanel_sqlBar__0HRL8 { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); }
[data-theme="dark"] .AssistantPanel_optionBtn__2q1lu { background: var(--color-bg-secondary); }
[data-theme="dark"] .AssistantPanel_smallBtn__E\\+0qG:hover:not(:disabled),
[data-theme="dark"] .AssistantPanel_optionBtn__2q1lu:hover:not(:disabled),
[data-theme="dark"] .AssistantPanel_exampleBtn__-olv8:hover,
[data-theme="dark"] .AssistantPanel_iconBtn__lpHX2:hover { background: var(--color-hover); }
[data-theme="dark"] .AssistantPanel_errorBubble__HdPzA { background: #3f1d1d; border-color: #7f1d1d; color: #fca5a5; }
[data-theme="dark"] .AssistantPanel_notice__EVeE0 { background: #3a2e10; border-color: #78350f; color: #fcd34d; }
[data-theme="dark"] .AssistantPanel_warn__IxUZL { color: #fbbf24; }

@media (prefers-reduced-motion: reduce) {
    .AssistantPanel_panel__-PJoL, .AssistantPanel_bubble__GNVvZ, .AssistantPanel_toolBody__qEyYj { animation: none; }
    .AssistantPanel_caret__nkmKD { animation: none; }
    .AssistantPanel_iconBtn__lpHX2, .AssistantPanel_smallBtn__E\\+0qG, .AssistantPanel_optionBtn__2q1lu, .AssistantPanel_exampleBtn__-olv8, .AssistantPanel_sendBtn__ZRfXD { transition: none; }
}

/* ── 튜닝 사례 원본 줄 (명세 1) ─────────────────────────────── */
.AssistantPanel_sourceBar__tPMAf {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-top: 1px solid var(--border-color, #333);
  font-size: 11px;
}
.AssistantPanel_sourceAddBtn__ZMQNh {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  border: 1px solid var(--border-color, #444);
  border-radius: 3px;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-size: 11px;
  transition: background-color 150ms ease, border-color 150ms ease;
}
.AssistantPanel_sourceAddBtn__ZMQNh:hover:not(:disabled) { background: var(--hover-bg, rgba(127, 127, 127, 0.12)); }
.AssistantPanel_sourceAddBtn__ZMQNh:disabled { opacity: 0.5; cursor: default; }
.AssistantPanel_sourceChip__zPXya {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  max-width: 190px;
  padding: 2px 5px;
  border: 1px solid var(--border-color, #444);
  border-radius: 3px;
  animation: AssistantPanel_source-chip-in__5AGLM 160ms ease-out;
}
.AssistantPanel_sourceChipWarn__bju0r { border-color: #d08a20; }

/* 말풍선 안의 첨부 — 본문 위에 작게. 보낸 뒤에도 "무엇을 붙였는지" 가 남아야 한다 */
.AssistantPanel_bubbleAttach__2vSfq {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 5px;
}
.AssistantPanel_bubbleAttachChip__6iLNb {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  max-width: 220px;
  padding: 1px 6px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.18);
  font-size: 10.5px;
  opacity: 0.92;
}
.AssistantPanel_sourceName__Ty\\+Uh { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.AssistantPanel_sourceDel__F-t4O {
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 0;
  opacity: 0.6;
  transition: opacity 150ms ease;
}
.AssistantPanel_sourceDel__F-t4O:hover { opacity: 1; }
.AssistantPanel_sourceWarn__xpTjg { color: #d08a20; }

@keyframes AssistantPanel_source-chip-in__5AGLM {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .AssistantPanel_sourceChip__zPXya { animation: none; }
  .AssistantPanel_sourceAddBtn__ZMQNh, .AssistantPanel_sourceDel__F-t4O { transition: none; }
}

/* ── 메타 정보원 리본 ────────────────────────────────────────── */
.AssistantPanel_ribbon__9vv5U {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 4px 8px;
  border-bottom: 1px solid var(--color-border, #e0e0e0);
  font-size: 10px;
}

/* 라벨 + 칩 묶음. **칩이 줄바꿈되면 라벨 오른쪽에서 이어진다**(내어쓰기) —
   예전에는 라벨과 칩이 한 flex 에 섞여 둘째 줄이 라벨 아래 왼쪽 끝에서 시작했다. */
.AssistantPanel_ribbonRow__-tefy {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}
.AssistantPanel_ribbonChips__0UTBu {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 3px;
  flex: 1 1;
  min-width: 0;
}
/* 라벨은 줄지 않고, 칩 첫 줄과 눈높이를 맞춘다 */
.AssistantPanel_ribbonLabel__npNPF {
  opacity: 0.55;
  flex-shrink: 0;
  white-space: nowrap;
  padding-top: 2px;
}
.AssistantPanel_ribbonChip__On8jD {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 1px 5px;
  border: 1px solid transparent;
  border-radius: 9px;
  background: rgba(127, 127, 127, 0.12);
  color: inherit;
  font-size: 10px;
  cursor: pointer;
  transition: background-color 150ms ease, opacity 150ms ease, border-color 150ms ease;
}
.AssistantPanel_ribbonChip__On8jD:disabled { cursor: default; }
/* 상태는 **채움과 글자색**으로 가른다. 투명도만 쓰면 다크 테마에서 뒤집혀 보인다 —
   실제로 "사용 안 함" 이 더 밝아 활성처럼 읽혔다. */

/* 사용 중 — 유일하게 채워진 칩. 한눈에 이것만 도드라져야 한다 */
.AssistantPanel_ribbon_on__8usRS {
    background: rgba(22, 122, 78, 0.16);
    border-color: rgba(22, 122, 78, 0.55);
    color: #14663f;
    font-weight: 600;
}

/* 사용 안 함 — 채우지 않는다. 취소선 + 흐린 글자로 확실히 물러나게 */
.AssistantPanel_ribbon_off__nQ-l2 {
    background: transparent;
    border-color: rgba(127, 127, 127, 0.35);
    color: var(--color-text-muted, #9ca3af);
    text-decoration: line-through;
}

/* 조건부 — 쓸 준비는 됐지만 지정·권한이 더 필요하다. 초록(사용 중)과 반드시 달라 보여야 한다 */
/* 조건부 — 테두리만 주황. 채우면 "사용 중" 과 헷갈린다 */
.AssistantPanel_ribbon_cond__DBjX\\+ { background: transparent; border-color: rgba(191, 122, 20, 0.6); color: #8a5b0c; }
/* 미존재 — 점선 + 가장 흐리게. 누를 수 없다는 것이 보여야 한다 */
.AssistantPanel_ribbon_missing__bMI1s {
    background: transparent;
    border-style: dashed;
    border-color: rgba(127, 127, 127, 0.35);
    color: var(--color-text-muted, #9ca3af);
    opacity: 0.7;
}
.AssistantPanel_ribbonChip__On8jD:not(:disabled):hover { background: rgba(127, 127, 127, 0.22); }
.AssistantPanel_ribbonRefresh__zyUKm {
  margin-left: auto;
  border: none;
  background: transparent;
  color: inherit;
  opacity: 0.5;
  cursor: pointer;
  padding: 0 2px;
  transition: opacity 150ms ease;
}
.AssistantPanel_ribbonRefresh__zyUKm:hover:not(:disabled) { opacity: 1; }

@media (prefers-reduced-motion: reduce) {
  .AssistantPanel_ribbonChip__On8jD, .AssistantPanel_ribbonRefresh__zyUKm { transition: none; }
}

/* 리본 다크 — 밝은 배경 기준 색은 다크에서 거의 안 보이거나 대비가 뒤집힌다 */
[data-theme="dark"] .AssistantPanel_ribbon_on__8usRS {
    background: rgba(52, 168, 110, 0.22);
    border-color: rgba(52, 168, 110, 0.65);
    color: #6ee7b0;
}
[data-theme="dark"] .AssistantPanel_ribbon_off__nQ-l2 {
    border-color: rgba(160, 160, 160, 0.3);
    color: #7c8590;
}
[data-theme="dark"] .AssistantPanel_ribbon_cond__DBjX\\+ {
    border-color: rgba(224, 178, 90, 0.6);
    color: #e0b25a;
}
[data-theme="dark"] .AssistantPanel_ribbon_missing__bMI1s {
    border-color: rgba(160, 160, 160, 0.28);
    color: #6b7280;
}

/* 파일 끌어다 놓기 — 입력 창 위에 놓을 곳을 보여 준다(2026-09-13). 누르기를 가로채지 않는다 */
.AssistantPanel_composer__SYO5M { position: relative; }
.AssistantPanel_dropOverlay__l7hGU {
    position: absolute;
    inset: 4px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border: 2px dashed var(--color-accent, #2563eb);
    border-radius: 6px;
    background: rgba(37, 99, 235, 0.08);
    color: var(--color-accent, #2563eb);
    font-size: 12px;
    font-weight: 600;
    pointer-events: none;
    animation: AssistantPanel_asst-drop-in__mxh\\+n 150ms ease-out;
}
.AssistantPanel_dropOverlayBusy__MTSRO {
    border-color: var(--color-border, #d1d5db);
    background: rgba(127, 127, 127, 0.1);
    color: var(--color-text-muted, #6b7280);
}
@keyframes AssistantPanel_asst-drop-in__mxh\\+n {
    from { opacity: 0; transform: translateY(-3px); }
    to { opacity: 1; transform: translateY(0); }
}
[data-theme="dark"] .AssistantPanel_dropOverlay__l7hGU {
    border-color: var(--color-accent-fg, #6cb6ff);
    background: rgba(108, 182, 255, 0.1);
    color: var(--color-accent-fg, #6cb6ff);
}
[data-theme="dark"] .AssistantPanel_dropOverlayBusy__MTSRO {
    border-color: var(--color-border);
    background: rgba(127, 127, 127, 0.12);
    color: var(--color-text-muted);
}
@media (prefers-reduced-motion: reduce) {
    .AssistantPanel_dropOverlay__l7hGU { animation: none; }
}

/* 작업 감시(원칙 8) — 감시 에이전트가 지켜보는 작업의 상태 한 줄. 나타날 때 짧게 */
.AssistantPanel_watchBar__bILlu {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin: 0 10px 6px;
    padding: 5px 8px;
    border: 1px solid var(--color-border, #e5e7eb);
    border-left: 3px solid var(--color-accent, #2f6fb0);
    border-radius: 4px;
    background: var(--color-bg-secondary, #f5f6f8);
    font-size: 11px;
    line-height: 1.45;
    animation: AssistantPanel_watchIn__aaS5P 160ms ease-out;
}
.AssistantPanel_watchBar__bILlu svg { flex-shrink: 0; margin-top: 2px; color: var(--color-accent, #2f6fb0); }
.AssistantPanel_watchText__Qa7N- { min-width: 0; overflow-wrap: anywhere; }
@keyframes AssistantPanel_watchIn__aaS5P { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }
@media (prefers-reduced-motion: reduce) { .AssistantPanel_watchBar__bILlu { animation: none; } }

/* 문서 칩에 붙는 「그림 N」 — 그 문서에서 꺼낸 그림 수(따로 칩으로 세우지 않는다) */
.AssistantPanel_sourceInner__tUooz { flex: 0 0 auto; padding: 0 5px; border-radius: 8px; font-size: 10px; background: rgba(127, 127, 127, 0.22); opacity: 0.85; white-space: nowrap; }

/* 대화 지우기 — 아이콘만으로는 무엇을 지우는지 알기 어려워 글자를 붙인다 */
.AssistantPanel_threadDelBtn__hzvFl { width: auto; padding: 0 7px; gap: 3px; display: inline-flex; align-items: center; font-size: 11.5px; white-space: nowrap; }

/* 가드레일 검사 결과 한 줄(보내기 전 검사, 2026-10-20) — 사용량 줄 아래 */
.AssistantPanel_guardLine__gz6b4 {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 2px 10px 4px;
    font-size: 10.5px;
    color: var(--color-text-muted, #6b7280);
}
.AssistantPanel_guardLink__7Uxk8 {
    margin-left: auto;
    padding: 0;
    border: none;
    background: none;
    color: var(--color-primary, #2563eb);
    font-size: 10.5px;
    cursor: pointer;
}
.AssistantPanel_guardLink__7Uxk8:hover { text-decoration: underline; }
`, "",{"version":3,"sources":["webpack://./src/components/assistant/AssistantPanel.module.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;IACI,YAAY;IACZ,kFAAkF;IAClF,cAAc;IACd,gBAAgB;IAChB;0DACsD;IACtD,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,iCAAiC;IACjC,mDAAmD;IACnD,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB;;0GAEsG;IACtG;+CAC2C;IAC3C,uDAAuD;AAC3D;;AAEA,mCAAa,eAAe,EAAE,UAAU,EAAE;;AAE1C;IACI,oBAAoB;IACpB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,+BAAS,gBAAgB,EAAE;AAC/B;;AAEA,kEAAkE;AAClE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,2CAA2C;IAC3C,eAAe;IACf,kFAAkF;AACtF;AACA,uCAAiB,uCAAuC,EAAE,iCAAiC,EAAE;AAC7F,0CAAoB,YAAY,EAAE,mBAAmB,EAAE;;AAEvD;yCACyC;AACzC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR;0DACsD;IACtD,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gEAAgE;AACpE;AACA;IACI,uCAAuC;IACvC,2CAA2C;AAC/C;AACA,oCAAc,0CAA0C,EAAE;;AAE1D;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA,wCAAkB,qBAAqB,EAAE;;AAEzC,4BAA4B;AAC5B,kCAAY,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAE5E,sDAAgC,mBAAmB,EAAE,cAAc,EAAE;;AAErE,8CAA8C;AAC9C;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,sBAAsB;IACtB,8CAA8C;AAClD;AACA,uEAA2B,SAAO,EAAE,eAAe,EAAE;;AAErD;IACI,+DAAmB,gBAAgB,EAAE;AACzC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,iCAAiC;IACjC,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,8CAA8C;IAC9C,qDAAqD;IACrD,eAAe;IACf,uCAAuC;AAC3C;AACA;gCACgC;AAChC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,2CAA2C;IAC3C,cAAc;AAClB;AACA,8BAAQ,cAAc,EAAE;;AAExB,yCAAyC;AACzC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,wDAAwD;IACxD,8CAA8C;IAC9C,iBAAiB;IACjB,uCAAuC;IACvC,wDAAkC;AACtC;AACA,kCAAY,aAAa,EAAE;AAC3B,mCAAa,iBAAiB,EAAE,kCAAkC,EAAE;;AAEpE,4CAAsB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC9D,0CAA0C,oCAAY,eAAe,EAAE,EAAE;;AAEzE;IACI,8CAA8C;AAClD;;AAEA,gDAAgD;AAChD;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;IAClB,oCAAoC;IACpC,2CAA2C;IAC3C,eAAe;IACf,eAAe;IACf,qDAAqD;AACzD;;AAEA;IACI,2CAA2C;IAC3C,oCAAoC;AACxC;;AAEA;0DAC0D;AAC1D;IAEI,cAAc;IACd,gBAAgB;AACpB;;AAEA,oFAAoF;AACpF;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,SAAS;AACb;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA,WAAW;AACX,0DAA0D;AAC1D;IACI,kBAAkB;IAClB,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA,qDAAqD;AACrD;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,8CAA8C;IAC9C,oBAAoB;IACpB,6CAA6C;IAC7C,iCAAiC;IACjC,eAAe;IACf,eAAe;IACf,yCAAyC;IACzC,sEAAgD;AACpD;;AAEA;IACI,2CAA2C;IAC3C,oCAAoC;AACxC;;AAEA;IACI,OAAO,UAAU,EAAE,2CAA2C,EAAE;IAChE,OAAO,UAAU,EAAE,yCAAyC,EAAE;AAClE;;AAEA;IACI,kCAAY,eAAe,EAAE;AACjC;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;AACA,sCAAgB,cAAc,EAAE,kBAAkB,EAAE,iCAAiC,EAAE,eAAe,EAAE;AACxG;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,8CAA8C;IAC9C,8CAA8C;IAC9C,kBAAkB;IAClB,2CAA2C;IAC3C,eAAe;IACf,eAAe;IACf,gEAAgE;AACpE;AACA,0CAAoB,uCAAuC,EAAE,iDAAiD,EAAE;;AAEhH;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,uDAAiC;AACrC;AACA;IACI,oBAAoB;IACpB,cAAc;IACd,wCAAwC;IACxC,WAAW;IACX,qBAAqB;AACzB;AACA,kDAAkD;AAClD;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,qCAAqC;IACrC,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,uCAAuC;AAC3C;AACA,wCAAkB,qCAAqC,EAAE;;AAEzD,0CAA0C,kCAAY,gBAAgB,EAAE,EAAE;;AAE1E;IACI,8CAA8C;IAC9C,8CAA8C;AAClD;AACA,qCAAwB,eAAe,EAAE;AACzC,gDAAmC,gBAAgB,EAAE;AACrD,2EAAiD,iBAAiB,EAAE,kBAAkB,EAAE;AACxF,yCAA4B,yBAAyB,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC1G,2EAAiD,8CAA8C,EAAE,gBAAgB,EAAE;AACnH;IACI,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;IAClB,+CAA+C;IAC/C,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,QAAQ;IACR,uBAAuB;AAC3B;;AAEA,YAAY;AACZ;IACI,eAAe;IACf,uCAAuC;IACvC,mDAAmD;IACnD,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,cAAc;IACd,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;AACA,kCAAY,gBAAgB,EAAE,2CAA2C,EAAE;AAC3E,kCAAY,cAAc,EAAE;AAC5B;IACI,eAAe;IACf,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;IAClB,+CAA+C;IAC/C,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,uDAAiC;AACrC;;AAEA,WAAW;AACX;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,8CAA8C;IAC9C,qDAAqD;AACzD;AACA,qCAAe,SAAO,EAAE,iBAAiB,EAAE,uCAAuC,EAAE,gBAAgB,EAAE;AACtG;IACI,SAAS;IACT,gBAAgB;IAChB,+CAA+C;IAC/C,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,oBAAoB;IACpB,mDAAmD;IACnD,eAAe;IACf,2CAA2C;IAC3C,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iCAAiC;IACjC,iCAAiC;IACjC,8CAA8C;IAC9C,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gEAAgE;AACpE;AACA,wDAAiC,uCAAuC,EAAE,iDAAiD,EAAE;AAC7H,4CAAqB,YAAY,EAAE,mBAAmB,EAAE;;AAExD,WAAW;AACX;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,iCAAiC;IACjC,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,6EAA6E;IAC7E,iBAAiB;IACjB,gBAAgB;IAChB,mCAAmC;AACvC;AACA,8EAA8E;AAC9E,sCAAgB,oBAAoB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,uBAAuB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC7I,iCAAW,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,oBAAoB,EAAE;AAClF;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,8CAA8C;IAC9C,8CAA8C;IAC9C,kBAAkB;IAClB,iCAAiC;IACjC,iBAAiB;IACjB,eAAe;IACf,gEAAgE;AACpE;AACA,wDAAkC,uCAAuC,EAAE,0CAA0C,EAAE;AACvH,4CAAsB,WAAW,EAAE,mBAAmB,EAAE;AACxD,oCAAc,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE,uCAAuC,EAAE;AAC3G,sCAAgB,0CAA0C,EAAE,6EAA6E,EAAE;AAC3I,uDAAuD;AACvD,kCAAY,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,uDAAiC,EAAE;AAChG,qCAAe,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,iBAAiB,EAAE;AAC5E;IACI,iBAAiB;IACjB,8CAA8C;IAC9C,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;IACnC,iBAAiB;IACjB,eAAe;IACf,mDAAmD;AACvD;AACA,6CAAuB,wCAAwC,EAAE,WAAW,EAAE;AAC9E,2CAAqB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AACpH,0CAA0C,kCAAY,eAAe,EAAE,EAAE,uCAAiB,gBAAgB,EAAE,EAAE;;AAE9G,kCAAW,aAAa,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AACxD;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,iCAAiC;IACjC,iCAAiC;IACjC,8CAA8C;IAC9C,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,uCAAuC;IACvC,mDAAmD;AACvD;AACA,yCAAmB,iCAAiC,EAAE;;AAEtD,YAAY;AACZ,mCAAa,YAAY,EAAE;AAC3B;IACI,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,4CAA4C;IAC5C,2BAA2B;IAC3B,uEAAiD;AACrD;AACA,8CAAwB,KAAK,kBAAkB,EAAE,EAAE;;AAEnD,QAAQ;AACR;IACI,cAAc;IACd,kDAAkD;IAClD,gBAAgB;IAChB,8CAA8C;AAClD;AACA;IACI,WAAW;IACX,kDAAkD;IAClD,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,iCAAiC;IACjC,8CAA8C;IAC9C,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA,wCAAkB,aAAa,EAAE,0CAA0C,EAAE;AAC7E,qCAAe,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC9E,sCAAgB,SAAO,EAAE,iBAAiB,EAAE,uCAAuC,EAAE;AACrF;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,wCAAwC;IACxC,WAAW;IACX,8CAA8C;IAC9C,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,8BAA8B;AAClC;AACA,0CAAoB,YAAY,EAAE,mBAAmB,EAAE;AACvD,kCAAY,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,uCAAuC,EAAE,eAAe,EAAE;;AAE9I,qBAAqB;AACrB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA,uCAAiB,cAAc,EAAE,kBAAkB,EAAE;;AAErD,UAAU;AACV,mDAAsC,2BAA2B,EAAE,sCAAsC,EAAE,wBAAwB,EAAE;AACrI;;sDAEyC,qCAAqC,EAAE,iCAAiC,EAAE;AACnH;sDACyC,qCAAqC,EAAE,iCAAiC,EAAE;AACnH;;;;;;;wDAO2C,2BAA2B,EAAE,wBAAwB,EAAE,iCAAiC,EAAE;AACrI,oDAAuC,qCAAqC,EAAE,wCAAwC,EAAE;AACxH,uDAA0C,qCAAqC,EAAE;AACjF;;;2DAG8C,8BAA8B,EAAE;AAC9E,yDAA4C,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACxG,oDAAuC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACnG,kDAAqC,cAAc,EAAE;;AAErD;IACI,+FAA6B,eAAe,EAAE;IAC9C,+BAAS,eAAe,EAAE;IAC1B,wKAAyD,gBAAgB,EAAE;AAC/E;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gEAAgE;AAClE;AACA,2DAAqC,sDAAsD,EAAE;AAC7F,+CAAyB,YAAY,EAAE,eAAe,EAAE;AACxD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,8DAAwC;AAC1C;AACA,wCAAkB,qBAAqB,EAAE;;AAEzC,qDAAqD;AACrD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,iBAAiB;EACjB,aAAa;AACf;AACA,qCAAc,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC9E;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,8BAA8B;AAChC;AACA,yCAAmB,UAAU,EAAE;AAC/B,oCAAc,cAAc,EAAE;;AAE9B;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,oCAAc,eAAe,EAAE;EAC/B,wEAA4B,gBAAgB,EAAE;AAChD;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,qDAAqD;EACrD,eAAe;AACjB;;AAEA;qDACqD;AACrD;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;AACA,+BAA+B;AAC/B;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,eAAe;EACf,oFAAoF;AACtF;AACA,6CAAuB,eAAe,EAAE;AACxC;kCACkC;;AAElC,wCAAwC;AACxC;IACI,mCAAmC;IACnC,qCAAqC;IACrC,cAAc;IACd,gBAAgB;AACpB;;AAEA,4CAA4C;AAC5C;IACI,uBAAuB;IACvB,uCAAuC;IACvC,uCAAuC;IACvC,6BAA6B;AACjC;;AAEA,2DAA2D;AAC3D,qCAAqC;AACrC,sCAAe,uBAAuB,EAAE,qCAAqC,EAAE,cAAc,EAAE;AAC/F,0CAA0C;AAC1C;IACI,uBAAuB;IACvB,oBAAoB;IACpB,uCAAuC;IACvC,uCAAuC;IACvC,YAAY;AAChB;AACA,yDAAmC,qCAAqC,EAAE;AAC1E;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;AACA,4DAAsC,UAAU,EAAE;;AAElD;EACE,0EAA8B,gBAAgB,EAAE;AAClD;;AAEA,gDAAgD;AAChD;IACI,oCAAoC;IACpC,sCAAsC;IACtC,cAAc;AAClB;AACA;IACI,sCAAsC;IACtC,cAAc;AAClB;AACA;IACI,qCAAqC;IACrC,cAAc;AAClB;AACA;IACI,uCAAuC;IACvC,cAAc;AAClB;;AAEA,+DAA+D;AAC/D,kCAAY,kBAAkB,EAAE;AAChC;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,+CAA+C;IAC/C,kBAAkB;IAClB,mCAAmC;IACnC,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,6DAAsC;AAC1C;AACA;IACI,0CAA0C;IAC1C,oCAAoC;IACpC,uCAAuC;AAC3C;AACA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;IACI,6CAA6C;IAC7C,oCAAoC;IACpC,sCAAsC;AAC1C;AACA;IACI,iCAAiC;IACjC,qCAAqC;IACrC,8BAA8B;AAClC;AACA;IACI,qCAAe,eAAe,EAAE;AACpC;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,8CAA8C;IAC9C,mDAAmD;IACnD,kBAAkB;IAClB,8CAA8C;IAC9C,eAAe;IACf,iBAAiB;IACjB,uDAAiC;AACrC;AACA,sCAAgB,cAAc,EAAE,eAAe,EAAE,mCAAmC,EAAE;AACtF,mCAAa,YAAY,EAAE,uBAAuB,EAAE;AACpD,2CAAqB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;AAC3G,0CAA0C,kCAAY,eAAe,EAAE,EAAE;;AAEzE,qDAAqD;AACrD,qCAAe,cAAc,EAAE,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE,qCAAqC,EAAE,aAAa,EAAE,mBAAmB,EAAE;;AAE/J,6CAA6C;AAC7C,sCAAgB,WAAW,EAAE,cAAc,EAAE,QAAQ,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;;AAE1I,oDAAoD;AACpD;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;IACrB,iBAAiB;IACjB,uCAAuC;AAC3C;AACA;IACI,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,oCAAoC;IACpC,iBAAiB;IACjB,eAAe;AACnB;AACA,yCAAmB,0BAA0B,EAAE","sourcesContent":["/* AssistantPanel — AI 에이전트 우측 패널 (AnalysisPanel 과 같은 레일 규격) */\r\n\r\n.panel {\r\n    width: 520px;\r\n    /* 편집기+결과 칸이 최소 폭에 닿으면 그다음은 패널이 줄어든다(App.css .editor-result-column) — 넘쳐서 잘리지 않게 */\r\n    flex-shrink: 1;\r\n    min-width: 340px;\r\n    /* 오른쪽 레일에서 **늘 맨 오른쪽**(사용자 요청 2026-09-13). 이력·챌린지·데이터 분석 패널보다 뒤에 온다 —\r\n       App.js 에서 그리는 순서가 바뀌어도 자리가 흔들리지 않게 순서를 여기서 못 박는다. */\r\n    order: 100;\r\n    display: flex;\r\n    flex-direction: column;\r\n    background: var(--color-bg, #fff);\r\n    border-left: 1px solid var(--color-border, #e0e0e0);\r\n    font-size: 12px;\r\n    color: var(--color-text, #1f2937);\r\n    overflow: hidden;\r\n    /* **폭이 아니라 여백을 움직인다.** 폭을 줄이면 안쪽이 그때마다 다시 배치돼 글자가\r\n       출렁인다. 음수 여백은 차지하는 자리만 줄이므로 내용은 그대로 있고 미닫이처럼 밀린다.\r\n       에이전트 칸의 최소 폭 전환(WorkspaceDock.css .ws-agent-col)과 시간이 같아야 한다. 패널은 접혀도 내려가지 않는다(늘 작동, 2026-10-20). */\r\n    /* 같은 레일의 사이드 패널(App.css .side-panel-area)과 **같은 시간**이다 — 둘이 다르면\r\n       버튼을 옮겨 누를 때 한쪽만 굼떠 보인다(신고 2026-09-20). */\r\n    transition: margin-right 260ms ease, opacity 200ms ease;\r\n}\r\n\r\n.panelOpen { margin-right: 0; opacity: 1; }\r\n\r\n.panelClosed {\r\n    margin-right: -520px;\r\n    opacity: 0;\r\n    pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n    .panel { transition: none; }\r\n}\r\n\r\n/* 제목줄·제목은 common/PanelHeader 가 그린다 — 여기서 또 칠하지 않는다(2026-09-20). */\r\n.iconBtn {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 24px;\r\n    height: 24px;\r\n    border: 1px solid transparent;\r\n    border-radius: 4px;\r\n    background: transparent;\r\n    color: var(--color-text-secondary, #4b5563);\r\n    cursor: pointer;\r\n    transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;\r\n}\r\n.iconBtn:hover { background: var(--color-hover, #eceef1); color: var(--color-text, #1f2937); }\r\n.iconBtn:disabled { opacity: .45; cursor: not-allowed; }\r\n\r\n/* 제목 옆 계정 배지 — 실행 전에 \"누구 계정으로 도는가\" 가 보여야 한다.\r\n   정상과 경고를 색으로 가른다: 계정이 없으면 턴이 아예 실패한다. */\r\n.acct, .acctWarn {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 3px;\r\n    /* 절대 찌그러지지 않는다. flex 기본값(shrink:1)이면 좁은 패널에서 글자가 통째로 잘려\r\n       아이콘과 말줄임표만 남는다 — 색만 보이고 뜻은 안 보이는 상태가 된다(실제로 그랬다). */\r\n    flex-shrink: 0;\r\n    padding: 1px 7px;\r\n    border-radius: 10px;\r\n    border: 1px solid transparent;\r\n    font-size: 10px;\r\n    line-height: 16px;\r\n    cursor: pointer;\r\n    transition: background-color 150ms ease, border-color 150ms ease;\r\n}\r\n.acct {\r\n    background: var(--color-hover, #eceef1);\r\n    color: var(--color-text-secondary, #4b5563);\r\n}\r\n.acct:hover { border-color: var(--color-border, #d1d5db); }\r\n\r\n.acctWarn {\r\n    background: #fef3c7;\r\n    color: #92400e;\r\n}\r\n.acctWarn:hover { border-color: #f59e0b; }\r\n\r\n/* 배지가 길어져도 아이콘·제목을 밀지 않는다 */\r\n.acctText { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\r\n\r\n[data-theme=\"dark\"] .acctWarn { background: #78350f; color: #fde68a; }\r\n\r\n/* 대화 선택 — 입력란 바로 위. 무엇에 이어서 쓰는지는 쓰기 직전에 본다. */\r\n.threadBar {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    flex-shrink: 0;\r\n    padding: 4px 8px 0 8px;\r\n    background: var(--color-bg-secondary, #f5f6f8);\r\n}\r\n.threadBar .threadSelect { flex: 1; max-width: none; }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n    .acct, .acctWarn { transition: none; }\r\n}\r\n\r\n.threadSelect {\r\n    max-width: 150px;\r\n    padding: 2px 4px;\r\n    font-size: 11px;\r\n    background: var(--color-bg, #fff);\r\n    color: var(--color-text, #1f2937);\r\n    border: 1px solid var(--color-border, #d1d5db);\r\n    border-radius: 4px;\r\n}\r\n\r\n/* 상황 표시줄 — 현재 연결/DB 종류, 세션 미바인딩 경고 */\r\n.context {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    flex-wrap: wrap;\r\n    padding: 5px 10px;\r\n    background: var(--color-bg-secondary, #f5f6f8);\r\n    border-bottom: 1px solid var(--color-border, #e0e0e0);\r\n    font-size: 11px;\r\n    color: var(--color-text-muted, #6b7280);\r\n}\r\n/* 배지는 **select 와 같은 높이**로 세운다. 텍스트 baseline 으로 두면 옆의 선택 상자보다\r\n   살짝 떠 보인다(실제 지적 2026-09-21). */\r\n.badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    min-height: 20px;\r\n    padding: 1px 6px;\r\n    border-radius: 10px;\r\n    background: var(--color-hover, #eceef1);\r\n    color: var(--color-text-secondary, #4b5563);\r\n    line-height: 1;\r\n}\r\n.warn { color: #b45309; }\r\n\r\n/* 토큰 사용량 — 항상 보이되 대화를 가리지 않게 가장 작고 흐리게 */\r\n.usageBar {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 3px 10px;\r\n    border-bottom: 1px solid var(--color-border-light, #eee);\r\n    background: var(--color-bg-secondary, #f5f6f8);\r\n    font-size: 10.5px;\r\n    color: var(--color-text-muted, #6b7280);\r\n    animation: usage-in 150ms ease-out;\r\n}\r\n.usageDim { opacity: 0.75; }\r\n.usageCost { margin-left: auto; font-variant-numeric: tabular-nums; }\r\n\r\n@keyframes usage-in { from { opacity: 0; } to { opacity: 1; } }\r\n@media (prefers-reduced-motion: reduce) { .usageBar { animation: none; } }\r\n\r\n:global([data-theme=\"dark\"]) .usageBar {\r\n    border-bottom-color: rgba(160, 160, 160, 0.18);\r\n}\r\n\r\n/* 스킬 수준 — 뱃지와 같은 줄에 두되 **누를 수 있다는 것**이 보여야 한다 */\r\n.skillSelect {\r\n    margin-left: auto;\r\n    max-width: 96px;\r\n    min-height: 20px;\r\n    padding: 1px 4px;\r\n    border: 1px solid var(--color-border, #d0d5dd);\r\n    border-radius: 4px;\r\n    background: var(--color-bg, #ffffff);\r\n    color: var(--color-text-secondary, #4b5563);\r\n    font-size: 11px;\r\n    cursor: pointer;\r\n    transition: border-color 150ms ease, color 150ms ease;\r\n}\r\n\r\n.skillSelect:hover {\r\n    border-color: var(--color-primary, #2f6fd0);\r\n    color: var(--color-primary, #2f6fd0);\r\n}\r\n\r\n/* 튜닝 수준은 문구가 길다(\"L6 Change Index\") — 스킬 수준과 같은 폭이면 잘린다.\r\n   `margin-left` 는 앞의 스킬 수준이 이미 auto 로 밀었으므로 여기서는 붙어 선다. */\r\n.tuneSelect {\r\n    composes: skillSelect;\r\n    margin-left: 0;\r\n    max-width: 168px;\r\n}\r\n\r\n/* 수준 칸의 레이블(2026-10-29) — 「스킬 수준 [개발자]」 「SQL 튜닝 수준 [L4 …]」. 오른쪽 끝으로 미는 것은 첫 칸이 한다 */\r\n.levelField {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    margin: 0;\r\n}\r\n.levelFieldFirst {\r\n    margin-left: auto;\r\n}\r\n.levelField .skillSelect {\r\n    margin-left: 0;\r\n}\r\n.levelLabel {\r\n    font-size: 11px;\r\n    color: var(--color-text-secondary, #6b7280);\r\n    white-space: nowrap;\r\n}\r\n\r\n/* 메시지 목록 */\r\n/* .list 를 감싸 \"맨 아래로\" 버튼을 띄울 자리를 만든다 — 스크롤과 같이 움직이면 안 된다 */\r\n.listWrap {\r\n    position: relative;\r\n    flex: 1;\r\n    min-height: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n/* 바닥에서 떨어져 있을 때만 나온다. 따라가기가 꺼졌다는 **표시**이자 되돌아갈 길이다 */\r\n.toBottom {\r\n    position: absolute;\r\n    left: 50%;\r\n    bottom: 10px;\r\n    transform: translateX(-50%);\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    padding: 4px 10px;\r\n    border: 1px solid var(--color-border, #d0d5dd);\r\n    border-radius: 999px;\r\n    background: var(--color-bg-elevated, #ffffff);\r\n    color: var(--color-text, #344054);\r\n    font-size: 11px;\r\n    cursor: pointer;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);\r\n    animation: assistant-to-bottom-in 150ms ease-out;\r\n}\r\n\r\n.toBottom:hover {\r\n    border-color: var(--color-primary, #2f6fd0);\r\n    color: var(--color-primary, #2f6fd0);\r\n}\r\n\r\n@keyframes assistant-to-bottom-in {\r\n    from { opacity: 0; transform: translateX(-50%) translateY(3px); }\r\n    to   { opacity: 1; transform: translateX(-50%) translateY(0); }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n    .toBottom { animation: none; }\r\n}\r\n\r\n:global([data-theme=\"dark\"]) .toBottom {\r\n    background: #23262b;\r\n    border-color: rgba(160, 160, 160, 0.32);\r\n    color: #d6dae0;\r\n}\r\n\r\n.list {\r\n    flex: 1;\r\n    min-height: 0;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    padding: 8px 10px 12px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n.empty {\r\n    margin: auto;\r\n    text-align: center;\r\n    color: var(--color-text-muted, #6b7280);\r\n    font-size: 11px;\r\n    line-height: 1.7;\r\n    padding: 16px;\r\n}\r\n.empty strong { display: block; margin-bottom: 6px; color: var(--color-text, #1f2937); font-size: 12px; }\r\n.exampleBtn {\r\n    display: block;\r\n    width: 100%;\r\n    margin-top: 6px;\r\n    padding: 6px 8px;\r\n    text-align: left;\r\n    background: var(--color-bg-secondary, #f5f6f8);\r\n    border: 1px solid var(--color-border, #e5e7eb);\r\n    border-radius: 4px;\r\n    color: var(--color-text-secondary, #4b5563);\r\n    font-size: 11px;\r\n    cursor: pointer;\r\n    transition: background-color 150ms ease, border-color 150ms ease;\r\n}\r\n.exampleBtn:hover { background: var(--color-hover, #eceef1); border-color: var(--color-border-strong, #9ca3af); }\r\n\r\n.bubble {\r\n    padding: 7px 9px;\r\n    border-radius: 6px;\r\n    line-height: 1.6;\r\n    word-break: break-word;\r\n    animation: asst-in 140ms ease-out;\r\n}\r\n.user {\r\n    align-self: flex-end;\r\n    max-width: 88%;\r\n    background: var(--color-accent, #2563eb);\r\n    color: #fff;\r\n    white-space: pre-wrap;\r\n}\r\n/* 긴 사용자 메시지의 펼치기 — 말풍선(파란 배경) 안이라 흰 글씨 기준으로 맞춘다 */\r\n.userMore {\r\n    display: block;\r\n    margin-top: 5px;\r\n    padding: 2px 7px;\r\n    border: 1px solid rgba(255, 255, 255, 0.45);\r\n    border-radius: 10px;\r\n    background: rgba(255, 255, 255, 0.14);\r\n    color: inherit;\r\n    font-size: 10.5px;\r\n    cursor: pointer;\r\n    transition: background-color 150ms ease;\r\n}\r\n.userMore:hover { background: rgba(255, 255, 255, 0.26); }\r\n\r\n@media (prefers-reduced-motion: reduce) { .userMore { transition: none; } }\r\n\r\n.assistant {\r\n    background: var(--color-bg-secondary, #f5f6f8);\r\n    border: 1px solid var(--color-border, #e5e7eb);\r\n}\r\n.assistant :global(p) { margin: 0 0 6px; }\r\n.assistant :global(p:last-child) { margin-bottom: 0; }\r\n.assistant :global(ul), .assistant :global(ol) { margin: 4px 0 6px; padding-left: 18px; }\r\n.assistant :global(table) { border-collapse: collapse; font-size: 11px; display: block; overflow-x: auto; }\r\n.assistant :global(th), .assistant :global(td) { border: 1px solid var(--color-border, #e5e7eb); padding: 2px 5px; }\r\n.assistant :global(code) {\r\n    background: var(--color-hover, #eceef1);\r\n    padding: 1px 4px;\r\n    border-radius: 3px;\r\n    font-family: Consolas, 'Courier New', monospace;\r\n    font-size: 11px;\r\n}\r\n\r\n.errorBubble {\r\n    background: #fef2f2;\r\n    border: 1px solid #fecaca;\r\n    color: #b91c1c;\r\n    display: flex;\r\n    gap: 6px;\r\n    align-items: flex-start;\r\n}\r\n\r\n/* 도구 호출 줄 */\r\n.tool {\r\n    font-size: 11px;\r\n    color: var(--color-text-muted, #6b7280);\r\n    border-left: 2px solid var(--color-border, #e5e7eb);\r\n    padding: 2px 0 2px 8px;\r\n}\r\n.toolHead {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    background: none;\r\n    border: none;\r\n    padding: 0;\r\n    color: inherit;\r\n    font: inherit;\r\n    cursor: pointer;\r\n    text-align: left;\r\n    width: 100%;\r\n}\r\n.toolName { font-weight: 600; color: var(--color-text-secondary, #4b5563); }\r\n.toolFail { color: #b91c1c; }\r\n.toolBody {\r\n    margin: 4px 0 0;\r\n    padding: 5px 6px;\r\n    background: var(--color-bg-secondary, #f5f6f8);\r\n    border-radius: 4px;\r\n    font-family: Consolas, 'Courier New', monospace;\r\n    font-size: 10.5px;\r\n    line-height: 1.5;\r\n    white-space: pre-wrap;\r\n    word-break: break-all;\r\n    max-height: 220px;\r\n    overflow: auto;\r\n    animation: asst-in 140ms ease-out;\r\n}\r\n\r\n/* SQL 블록 */\r\n.sqlBlock {\r\n    border: 1px solid var(--color-border, #e5e7eb);\r\n    border-radius: 6px;\r\n    overflow: hidden;\r\n    background: var(--color-bg, #fff);\r\n}\r\n.sqlBar {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    padding: 4px 6px;\r\n    background: var(--color-bg-secondary, #f5f6f8);\r\n    border-bottom: 1px solid var(--color-border, #e5e7eb);\r\n}\r\n.sqlBarLabel { flex: 1; font-size: 10.5px; color: var(--color-text-muted, #6b7280); font-weight: 600; }\r\n.sqlCode {\r\n    margin: 0;\r\n    padding: 7px 8px;\r\n    font-family: Consolas, 'Courier New', monospace;\r\n    font-size: 11.5px;\r\n    line-height: 1.55;\r\n    white-space: pre;\r\n    overflow-x: auto;\r\n}\r\n.rationale {\r\n    padding: 5px 8px 7px;\r\n    border-top: 1px dashed var(--color-border, #e5e7eb);\r\n    font-size: 11px;\r\n    color: var(--color-text-secondary, #4b5563);\r\n    line-height: 1.6;\r\n    white-space: pre-wrap;\r\n}\r\n.smallBtn {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 3px;\r\n    padding: 3px 8px;\r\n    background: var(--color-bg, #fff);\r\n    color: var(--color-text, #1f2937);\r\n    border: 1px solid var(--color-border, #d1d5db);\r\n    border-radius: 4px;\r\n    font-size: 10.5px;\r\n    cursor: pointer;\r\n    transition: background-color 150ms ease, border-color 150ms ease;\r\n}\r\n.smallBtn:hover:not(:disabled) { background: var(--color-hover, #f3f4f6); border-color: var(--color-border-strong, #9ca3af); }\r\n.smallBtn:disabled { opacity: .45; cursor: not-allowed; }\r\n\r\n/* 되묻기 카드 */\r\n.question {\r\n    border: 1px solid var(--color-accent, #2563eb);\r\n    border-radius: 6px;\r\n    background: var(--color-bg, #fff);\r\n    overflow: hidden;\r\n}\r\n.questionHead {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    padding: 5px 8px;\r\n    background: color-mix(in srgb, var(--color-accent, #2563eb) 10%, transparent);\r\n    font-size: 10.5px;\r\n    font-weight: 600;\r\n    color: var(--color-accent, #2563eb);\r\n}\r\n/* 줄바꿈을 살린다 — 승인 창(임시 인덱스·execute_sql)은 실행할 문장을 여러 줄로 보여 준다. 긴 문장은 칸 안에서 스크롤 */\r\n.questionText { padding: 7px 8px 4px; line-height: 1.6; white-space: pre-wrap; overflow-wrap: anywhere; max-height: 320px; overflow-y: auto; }\r\n.options { display: flex; flex-direction: column; gap: 4px; padding: 4px 8px 8px; }\r\n.optionBtn {\r\n    display: block;\r\n    width: 100%;\r\n    text-align: left;\r\n    padding: 6px 8px;\r\n    background: var(--color-bg-secondary, #f5f6f8);\r\n    border: 1px solid var(--color-border, #d1d5db);\r\n    border-radius: 4px;\r\n    color: var(--color-text, #1f2937);\r\n    font-size: 11.5px;\r\n    cursor: pointer;\r\n    transition: background-color 150ms ease, border-color 150ms ease;\r\n}\r\n.optionBtn:hover:not(:disabled) { background: var(--color-hover, #eceef1); border-color: var(--color-accent, #2563eb); }\r\n.optionBtn:disabled { opacity: .5; cursor: not-allowed; }\r\n.optionDesc { display: block; margin-top: 2px; font-size: 10.5px; color: var(--color-text-muted, #6b7280); }\r\n.optionPicked { border-color: var(--color-accent, #2563eb); background: color-mix(in srgb, var(--color-accent, #2563eb) 12%, transparent); }\r\n/* 도움말 안내 + 선택 버튼 — 되묻기 카드와 달리 가로로 감싼다(라벨이 짧고 개수가 많다) */\r\n.helpWrap { display: flex; flex-direction: column; gap: 6px; animation: help-in 160ms ease-out; }\r\n.helpOptions { display: flex; flex-wrap: wrap; gap: 5px; padding-left: 4px; }\r\n.helpOptionBtn {\r\n    padding: 4px 10px;\r\n    border: 1px solid var(--color-accent, #2563eb);\r\n    border-radius: 14px;\r\n    background: transparent;\r\n    color: var(--color-accent, #2563eb);\r\n    font-size: 11.5px;\r\n    cursor: pointer;\r\n    transition: background 150ms ease, color 150ms ease;\r\n}\r\n.helpOptionBtn:hover { background: var(--color-accent, #2563eb); color: #fff; }\r\n@keyframes help-in { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }\r\n@media (prefers-reduced-motion: reduce) { .helpWrap { animation: none; } .helpOptionBtn { transition: none; } }\r\n\r\n.freeRow { display: flex; gap: 4px; padding: 0 8px 8px; }\r\n.freeInput {\r\n    flex: 1;\r\n    min-width: 0;\r\n    padding: 5px 7px;\r\n    background: var(--color-bg, #fff);\r\n    color: var(--color-text, #1f2937);\r\n    border: 1px solid var(--color-border, #d1d5db);\r\n    border-radius: 4px;\r\n    font-size: 11.5px;\r\n}\r\n.resolved {\r\n    padding: 5px 8px 7px;\r\n    font-size: 11px;\r\n    color: var(--color-text-muted, #6b7280);\r\n    border-top: 1px dashed var(--color-border, #e5e7eb);\r\n}\r\n.resolved strong { color: var(--color-text, #1f2937); }\r\n\r\n/* 스트리밍 표시 */\r\n.streaming { opacity: .85; }\r\n.caret {\r\n    display: inline-block;\r\n    width: 6px;\r\n    height: 12px;\r\n    margin-left: 2px;\r\n    background: var(--color-text-muted, #6b7280);\r\n    vertical-align: text-bottom;\r\n    animation: asst-blink 1s steps(2, start) infinite;\r\n}\r\n@keyframes asst-blink { to { visibility: hidden; } }\r\n\r\n/* 입력창 */\r\n.composer {\r\n    flex-shrink: 0;\r\n    border-top: 1px solid var(--color-border, #e0e0e0);\r\n    padding: 7px 8px;\r\n    background: var(--color-bg-secondary, #f5f6f8);\r\n}\r\n.textarea {\r\n    width: 100%;\r\n    /* 같은 규칙에 min-height 를 두 번 쓰면 뒤엣것이 이긴다 — 한 번만 둔다 */\r\n    min-height: 88px;\r\n    max-height: 320px;\r\n    resize: vertical;\r\n    padding: 6px 7px;\r\n    background: var(--color-bg, #fff);\r\n    color: var(--color-text, #1f2937);\r\n    border: 1px solid var(--color-border, #d1d5db);\r\n    border-radius: 4px;\r\n    font-family: inherit;\r\n    font-size: 12px;\r\n    line-height: 1.5;\r\n    box-sizing: border-box;\r\n}\r\n.textarea:focus { outline: none; border-color: var(--color-accent, #2563eb); }\r\n.composerBar { display: flex; align-items: center; gap: 6px; margin-top: 5px; }\r\n.composerHint { flex: 1; font-size: 10.5px; color: var(--color-text-muted, #6b7280); }\r\n.sendBtn {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    padding: 5px 12px;\r\n    background: var(--color-accent, #2563eb);\r\n    color: #fff;\r\n    border: 1px solid var(--color-accent, #2563eb);\r\n    border-radius: 4px;\r\n    font-size: 11.5px;\r\n    cursor: pointer;\r\n    transition: opacity 150ms ease;\r\n}\r\n.sendBtn:disabled { opacity: .45; cursor: not-allowed; }\r\n.checkbox { display: inline-flex; align-items: center; gap: 4px; font-size: 10.5px; color: var(--color-text-muted, #6b7280); cursor: pointer; }\r\n\r\n/* 계정 안내(로그인/토큰 없음) */\r\n.notice {\r\n    margin: 8px 10px;\r\n    padding: 8px 10px;\r\n    background: #fffbeb;\r\n    border: 1px solid #fde68a;\r\n    border-radius: 6px;\r\n    font-size: 11px;\r\n    line-height: 1.6;\r\n    color: #92400e;\r\n}\r\n.notice strong { display: block; margin-bottom: 3px; }\r\n\r\n/* 다크 테마 */\r\n:global([data-theme=\"dark\"]) .panel { background: var(--color-bg); border-left-color: var(--color-border); color: var(--color-text); }\r\n:global([data-theme=\"dark\"]) .header,\r\n:global([data-theme=\"dark\"]) .context,\r\n:global([data-theme=\"dark\"]) .composer { background: var(--color-bg-secondary); border-color: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .assistant,\r\n:global([data-theme=\"dark\"]) .toolBody { background: var(--color-bg-secondary); border-color: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .sqlBlock,\r\n:global([data-theme=\"dark\"]) .question,\r\n:global([data-theme=\"dark\"]) .threadSelect,\r\n:global([data-theme=\"dark\"]) .textarea,\r\n:global([data-theme=\"dark\"]) .freeInput,\r\n:global([data-theme=\"dark\"]) .smallBtn,\r\n:global([data-theme=\"dark\"]) .optionBtn,\r\n:global([data-theme=\"dark\"]) .exampleBtn { background: var(--color-bg); color: var(--color-text); border-color: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .sqlBar { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); }\r\n:global([data-theme=\"dark\"]) .optionBtn { background: var(--color-bg-secondary); }\r\n:global([data-theme=\"dark\"]) .smallBtn:hover:not(:disabled),\r\n:global([data-theme=\"dark\"]) .optionBtn:hover:not(:disabled),\r\n:global([data-theme=\"dark\"]) .exampleBtn:hover,\r\n:global([data-theme=\"dark\"]) .iconBtn:hover { background: var(--color-hover); }\r\n:global([data-theme=\"dark\"]) .errorBubble { background: #3f1d1d; border-color: #7f1d1d; color: #fca5a5; }\r\n:global([data-theme=\"dark\"]) .notice { background: #3a2e10; border-color: #78350f; color: #fcd34d; }\r\n:global([data-theme=\"dark\"]) .warn { color: #fbbf24; }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n    .panel, .bubble, .toolBody { animation: none; }\r\n    .caret { animation: none; }\r\n    .iconBtn, .smallBtn, .optionBtn, .exampleBtn, .sendBtn { transition: none; }\r\n}\r\n\r\n/* ── 튜닝 사례 원본 줄 (명세 1) ─────────────────────────────── */\r\n.sourceBar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 4px 8px;\r\n  border-top: 1px solid var(--border-color, #333);\r\n  font-size: 11px;\r\n}\r\n.sourceAddBtn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 3px;\r\n  padding: 2px 6px;\r\n  border: 1px solid var(--border-color, #444);\r\n  border-radius: 3px;\r\n  background: transparent;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  font-size: 11px;\r\n  transition: background-color 150ms ease, border-color 150ms ease;\r\n}\r\n.sourceAddBtn:hover:not(:disabled) { background: var(--hover-bg, rgba(127, 127, 127, 0.12)); }\r\n.sourceAddBtn:disabled { opacity: 0.5; cursor: default; }\r\n.sourceChip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 3px;\r\n  max-width: 190px;\r\n  padding: 2px 5px;\r\n  border: 1px solid var(--border-color, #444);\r\n  border-radius: 3px;\r\n  animation: source-chip-in 160ms ease-out;\r\n}\r\n.sourceChipWarn { border-color: #d08a20; }\r\n\r\n/* 말풍선 안의 첨부 — 본문 위에 작게. 보낸 뒤에도 \"무엇을 붙였는지\" 가 남아야 한다 */\r\n.bubbleAttach {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n  margin-bottom: 5px;\r\n}\r\n.bubbleAttachChip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 3px;\r\n  max-width: 220px;\r\n  padding: 1px 6px;\r\n  border-radius: 10px;\r\n  background: rgba(255, 255, 255, 0.18);\r\n  font-size: 10.5px;\r\n  opacity: 0.92;\r\n}\r\n.sourceName { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\r\n.sourceDel {\r\n  border: none;\r\n  background: transparent;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  opacity: 0.6;\r\n  transition: opacity 150ms ease;\r\n}\r\n.sourceDel:hover { opacity: 1; }\r\n.sourceWarn { color: #d08a20; }\r\n\r\n@keyframes source-chip-in {\r\n  from { opacity: 0; transform: translateY(-3px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .sourceChip { animation: none; }\r\n  .sourceAddBtn, .sourceDel { transition: none; }\r\n}\r\n\r\n/* ── 메타 정보원 리본 ────────────────────────────────────────── */\r\n.ribbon {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n  padding: 4px 8px;\r\n  border-bottom: 1px solid var(--color-border, #e0e0e0);\r\n  font-size: 10px;\r\n}\r\n\r\n/* 라벨 + 칩 묶음. **칩이 줄바꿈되면 라벨 오른쪽에서 이어진다**(내어쓰기) —\r\n   예전에는 라벨과 칩이 한 flex 에 섞여 둘째 줄이 라벨 아래 왼쪽 끝에서 시작했다. */\r\n.ribbonRow {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 4px;\r\n}\r\n.ribbonChips {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 3px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n/* 라벨은 줄지 않고, 칩 첫 줄과 눈높이를 맞춘다 */\r\n.ribbonLabel {\r\n  opacity: 0.55;\r\n  flex-shrink: 0;\r\n  white-space: nowrap;\r\n  padding-top: 2px;\r\n}\r\n.ribbonChip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  padding: 1px 5px;\r\n  border: 1px solid transparent;\r\n  border-radius: 9px;\r\n  background: rgba(127, 127, 127, 0.12);\r\n  color: inherit;\r\n  font-size: 10px;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease, opacity 150ms ease, border-color 150ms ease;\r\n}\r\n.ribbonChip:disabled { cursor: default; }\r\n/* 상태는 **채움과 글자색**으로 가른다. 투명도만 쓰면 다크 테마에서 뒤집혀 보인다 —\r\n   실제로 \"사용 안 함\" 이 더 밝아 활성처럼 읽혔다. */\r\n\r\n/* 사용 중 — 유일하게 채워진 칩. 한눈에 이것만 도드라져야 한다 */\r\n.ribbon_on {\r\n    background: rgba(22, 122, 78, 0.16);\r\n    border-color: rgba(22, 122, 78, 0.55);\r\n    color: #14663f;\r\n    font-weight: 600;\r\n}\r\n\r\n/* 사용 안 함 — 채우지 않는다. 취소선 + 흐린 글자로 확실히 물러나게 */\r\n.ribbon_off {\r\n    background: transparent;\r\n    border-color: rgba(127, 127, 127, 0.35);\r\n    color: var(--color-text-muted, #9ca3af);\r\n    text-decoration: line-through;\r\n}\r\n\r\n/* 조건부 — 쓸 준비는 됐지만 지정·권한이 더 필요하다. 초록(사용 중)과 반드시 달라 보여야 한다 */\r\n/* 조건부 — 테두리만 주황. 채우면 \"사용 중\" 과 헷갈린다 */\r\n.ribbon_cond { background: transparent; border-color: rgba(191, 122, 20, 0.6); color: #8a5b0c; }\r\n/* 미존재 — 점선 + 가장 흐리게. 누를 수 없다는 것이 보여야 한다 */\r\n.ribbon_missing {\r\n    background: transparent;\r\n    border-style: dashed;\r\n    border-color: rgba(127, 127, 127, 0.35);\r\n    color: var(--color-text-muted, #9ca3af);\r\n    opacity: 0.7;\r\n}\r\n.ribbonChip:not(:disabled):hover { background: rgba(127, 127, 127, 0.22); }\r\n.ribbonRefresh {\r\n  margin-left: auto;\r\n  border: none;\r\n  background: transparent;\r\n  color: inherit;\r\n  opacity: 0.5;\r\n  cursor: pointer;\r\n  padding: 0 2px;\r\n  transition: opacity 150ms ease;\r\n}\r\n.ribbonRefresh:hover:not(:disabled) { opacity: 1; }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .ribbonChip, .ribbonRefresh { transition: none; }\r\n}\r\n\r\n/* 리본 다크 — 밝은 배경 기준 색은 다크에서 거의 안 보이거나 대비가 뒤집힌다 */\r\n:global([data-theme=\"dark\"]) .ribbon_on {\r\n    background: rgba(52, 168, 110, 0.22);\r\n    border-color: rgba(52, 168, 110, 0.65);\r\n    color: #6ee7b0;\r\n}\r\n:global([data-theme=\"dark\"]) .ribbon_off {\r\n    border-color: rgba(160, 160, 160, 0.3);\r\n    color: #7c8590;\r\n}\r\n:global([data-theme=\"dark\"]) .ribbon_cond {\r\n    border-color: rgba(224, 178, 90, 0.6);\r\n    color: #e0b25a;\r\n}\r\n:global([data-theme=\"dark\"]) .ribbon_missing {\r\n    border-color: rgba(160, 160, 160, 0.28);\r\n    color: #6b7280;\r\n}\r\n\r\n/* 파일 끌어다 놓기 — 입력 창 위에 놓을 곳을 보여 준다(2026-09-13). 누르기를 가로채지 않는다 */\r\n.composer { position: relative; }\r\n.dropOverlay {\r\n    position: absolute;\r\n    inset: 4px;\r\n    z-index: 2;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 6px;\r\n    border: 2px dashed var(--color-accent, #2563eb);\r\n    border-radius: 6px;\r\n    background: rgba(37, 99, 235, 0.08);\r\n    color: var(--color-accent, #2563eb);\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    pointer-events: none;\r\n    animation: asst-drop-in 150ms ease-out;\r\n}\r\n.dropOverlayBusy {\r\n    border-color: var(--color-border, #d1d5db);\r\n    background: rgba(127, 127, 127, 0.1);\r\n    color: var(--color-text-muted, #6b7280);\r\n}\r\n@keyframes asst-drop-in {\r\n    from { opacity: 0; transform: translateY(-3px); }\r\n    to { opacity: 1; transform: translateY(0); }\r\n}\r\n:global([data-theme=\"dark\"]) .dropOverlay {\r\n    border-color: var(--color-accent-fg, #6cb6ff);\r\n    background: rgba(108, 182, 255, 0.1);\r\n    color: var(--color-accent-fg, #6cb6ff);\r\n}\r\n:global([data-theme=\"dark\"]) .dropOverlayBusy {\r\n    border-color: var(--color-border);\r\n    background: rgba(127, 127, 127, 0.12);\r\n    color: var(--color-text-muted);\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n    .dropOverlay { animation: none; }\r\n}\r\n\r\n/* 작업 감시(원칙 8) — 감시 에이전트가 지켜보는 작업의 상태 한 줄. 나타날 때 짧게 */\r\n.watchBar {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 6px;\r\n    margin: 0 10px 6px;\r\n    padding: 5px 8px;\r\n    border: 1px solid var(--color-border, #e5e7eb);\r\n    border-left: 3px solid var(--color-accent, #2f6fb0);\r\n    border-radius: 4px;\r\n    background: var(--color-bg-secondary, #f5f6f8);\r\n    font-size: 11px;\r\n    line-height: 1.45;\r\n    animation: watchIn 160ms ease-out;\r\n}\r\n.watchBar svg { flex-shrink: 0; margin-top: 2px; color: var(--color-accent, #2f6fb0); }\r\n.watchText { min-width: 0; overflow-wrap: anywhere; }\r\n@keyframes watchIn { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: none; } }\r\n@media (prefers-reduced-motion: reduce) { .watchBar { animation: none; } }\r\n\r\n/* 문서 칩에 붙는 「그림 N」 — 그 문서에서 꺼낸 그림 수(따로 칩으로 세우지 않는다) */\r\n.sourceInner { flex: 0 0 auto; padding: 0 5px; border-radius: 8px; font-size: 10px; background: rgba(127, 127, 127, 0.22); opacity: 0.85; white-space: nowrap; }\r\n\r\n/* 대화 지우기 — 아이콘만으로는 무엇을 지우는지 알기 어려워 글자를 붙인다 */\r\n.threadDelBtn { width: auto; padding: 0 7px; gap: 3px; display: inline-flex; align-items: center; font-size: 11.5px; white-space: nowrap; }\r\n\r\n/* 가드레일 검사 결과 한 줄(보내기 전 검사, 2026-10-20) — 사용량 줄 아래 */\r\n.guardLine {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    padding: 2px 10px 4px;\r\n    font-size: 10.5px;\r\n    color: var(--color-text-muted, #6b7280);\r\n}\r\n.guardLink {\r\n    margin-left: auto;\r\n    padding: 0;\r\n    border: none;\r\n    background: none;\r\n    color: var(--color-primary, #2563eb);\r\n    font-size: 10.5px;\r\n    cursor: pointer;\r\n}\r\n.guardLink:hover { text-decoration: underline; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `AssistantPanel_panel__-PJoL`,
	"panelOpen": `AssistantPanel_panelOpen__bsjlx`,
	"panelClosed": `AssistantPanel_panelClosed__TmE1J`,
	"iconBtn": `AssistantPanel_iconBtn__lpHX2`,
	"acct": `AssistantPanel_acct__BZAzy`,
	"acctWarn": `AssistantPanel_acctWarn__ztOq8`,
	"acctText": `AssistantPanel_acctText__TzKi0`,
	"threadBar": `AssistantPanel_threadBar__oVw3Y`,
	"threadSelect": `AssistantPanel_threadSelect__defYk`,
	"context": `AssistantPanel_context__N7Qri`,
	"badge": `AssistantPanel_badge__Gpt0h`,
	"warn": `AssistantPanel_warn__IxUZL`,
	"usageBar": `AssistantPanel_usageBar__i+f+F`,
	"usage-in": `AssistantPanel_usage-in__VunZ0`,
	"usageDim": `AssistantPanel_usageDim__R3TNe`,
	"usageCost": `AssistantPanel_usageCost__odyXR`,
	"skillSelect": `AssistantPanel_skillSelect__zpEcJ`,
	"tuneSelect": `AssistantPanel_tuneSelect__e1a4P AssistantPanel_skillSelect__zpEcJ`,
	"levelField": `AssistantPanel_levelField__BrAjA`,
	"levelFieldFirst": `AssistantPanel_levelFieldFirst__A1SWS`,
	"levelLabel": `AssistantPanel_levelLabel__SbkTD`,
	"listWrap": `AssistantPanel_listWrap__7RCtX`,
	"toBottom": `AssistantPanel_toBottom__KNUQf`,
	"assistant-to-bottom-in": `AssistantPanel_assistant-to-bottom-in__sztq1`,
	"list": `AssistantPanel_list__sxBm8`,
	"empty": `AssistantPanel_empty__TSgsD`,
	"exampleBtn": `AssistantPanel_exampleBtn__-olv8`,
	"bubble": `AssistantPanel_bubble__GNVvZ`,
	"asst-in": `AssistantPanel_asst-in__RcjcK`,
	"user": `AssistantPanel_user__nPm6f`,
	"userMore": `AssistantPanel_userMore__whgPP`,
	"assistant": `AssistantPanel_assistant__3UAfH`,
	"errorBubble": `AssistantPanel_errorBubble__HdPzA`,
	"tool": `AssistantPanel_tool__uwWkJ`,
	"toolHead": `AssistantPanel_toolHead__Z7260`,
	"toolName": `AssistantPanel_toolName__vEofV`,
	"toolFail": `AssistantPanel_toolFail__G9-0-`,
	"toolBody": `AssistantPanel_toolBody__qEyYj`,
	"sqlBlock": `AssistantPanel_sqlBlock__3dF+H`,
	"sqlBar": `AssistantPanel_sqlBar__0HRL8`,
	"sqlBarLabel": `AssistantPanel_sqlBarLabel__RKxnT`,
	"sqlCode": `AssistantPanel_sqlCode__Y+3tj`,
	"rationale": `AssistantPanel_rationale__2VtvM`,
	"smallBtn": `AssistantPanel_smallBtn__E+0qG`,
	"question": `AssistantPanel_question__PP7uB`,
	"questionHead": `AssistantPanel_questionHead__N9z6A`,
	"questionText": `AssistantPanel_questionText__398-m`,
	"options": `AssistantPanel_options__HrNR5`,
	"optionBtn": `AssistantPanel_optionBtn__2q1lu`,
	"optionDesc": `AssistantPanel_optionDesc__ePIkI`,
	"optionPicked": `AssistantPanel_optionPicked__8Fk4g`,
	"helpWrap": `AssistantPanel_helpWrap__e6PdW`,
	"help-in": `AssistantPanel_help-in__HaYV2`,
	"helpOptions": `AssistantPanel_helpOptions__pln5m`,
	"helpOptionBtn": `AssistantPanel_helpOptionBtn__VHOSG`,
	"freeRow": `AssistantPanel_freeRow__NiJ+Z`,
	"freeInput": `AssistantPanel_freeInput__-te5r`,
	"resolved": `AssistantPanel_resolved__rjONg`,
	"streaming": `AssistantPanel_streaming__1Zems`,
	"caret": `AssistantPanel_caret__nkmKD`,
	"asst-blink": `AssistantPanel_asst-blink__wlxSa`,
	"composer": `AssistantPanel_composer__SYO5M`,
	"textarea": `AssistantPanel_textarea__w586V`,
	"composerBar": `AssistantPanel_composerBar__kv41J`,
	"composerHint": `AssistantPanel_composerHint__kzbBW`,
	"sendBtn": `AssistantPanel_sendBtn__ZRfXD`,
	"checkbox": `AssistantPanel_checkbox__9vhJW`,
	"notice": `AssistantPanel_notice__EVeE0`,
	"header": `AssistantPanel_header__pzQ8K`,
	"sourceBar": `AssistantPanel_sourceBar__tPMAf`,
	"sourceAddBtn": `AssistantPanel_sourceAddBtn__ZMQNh`,
	"sourceChip": `AssistantPanel_sourceChip__zPXya`,
	"source-chip-in": `AssistantPanel_source-chip-in__5AGLM`,
	"sourceChipWarn": `AssistantPanel_sourceChipWarn__bju0r`,
	"bubbleAttach": `AssistantPanel_bubbleAttach__2vSfq`,
	"bubbleAttachChip": `AssistantPanel_bubbleAttachChip__6iLNb`,
	"sourceName": `AssistantPanel_sourceName__Ty+Uh`,
	"sourceDel": `AssistantPanel_sourceDel__F-t4O`,
	"sourceWarn": `AssistantPanel_sourceWarn__xpTjg`,
	"ribbon": `AssistantPanel_ribbon__9vv5U`,
	"ribbonRow": `AssistantPanel_ribbonRow__-tefy`,
	"ribbonChips": `AssistantPanel_ribbonChips__0UTBu`,
	"ribbonLabel": `AssistantPanel_ribbonLabel__npNPF`,
	"ribbonChip": `AssistantPanel_ribbonChip__On8jD`,
	"ribbon_on": `AssistantPanel_ribbon_on__8usRS`,
	"ribbon_off": `AssistantPanel_ribbon_off__nQ-l2`,
	"ribbon_cond": `AssistantPanel_ribbon_cond__DBjX+`,
	"ribbon_missing": `AssistantPanel_ribbon_missing__bMI1s`,
	"ribbonRefresh": `AssistantPanel_ribbonRefresh__zyUKm`,
	"dropOverlay": `AssistantPanel_dropOverlay__l7hGU`,
	"asst-drop-in": `AssistantPanel_asst-drop-in__mxh+n`,
	"dropOverlayBusy": `AssistantPanel_dropOverlayBusy__MTSRO`,
	"watchBar": `AssistantPanel_watchBar__bILlu`,
	"watchIn": `AssistantPanel_watchIn__aaS5P`,
	"watchText": `AssistantPanel_watchText__Qa7N-`,
	"sourceInner": `AssistantPanel_sourceInner__tUooz`,
	"threadDelBtn": `AssistantPanel_threadDelBtn__hzvFl`,
	"guardLine": `AssistantPanel_guardLine__gz6b4`,
	"guardLink": `AssistantPanel_guardLink__7Uxk8`
};
export default ___CSS_LOADER_EXPORT___;
